
import { useEffect, useState, useRef } from "react";
import React from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import { AiOutlineProject } from "react-icons/ai";
import {
  MdAssignmentInd,
  MdDelete,
  MdOutlineLowPriority,
  MdPreview,
} from "react-icons/md";
import { BiTask } from "react-icons/bi";
import { BsTextParagraph } from "react-icons/bs";
import Modal from "react-modal";
import "./../style/modal.css";
import "./../style/common.css";
import { TextField, MenuItem } from "@mui/material"; //for modal textfield
import { Calendar } from "react-date-range"; //for single date selection
import "react-date-range/dist/styles.css"; // Main CSS file
import "react-date-range/dist/theme/default.css"; // Theme CSS file
import { enUS } from "date-fns/locale"; // Import locale data
import { FaCalendarAlt, FaFileUpload } from "react-icons/fa";
import { InputAdornment } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { BsListCheck } from "react-icons/bs";
import dayjs from "dayjs";
import { CiWarning } from "react-icons/ci";

import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slider,
} from "@mui/material";


const TaskPage = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true); //loader
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [project, setProject] = useState([]);
  const [employee, setEmployees] = useState([]);
  const [showDeleteBox, setShowDeleteBox] = useState(false);
  const [deleteServiceName, setDeleteServiceName] = useState("");
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [errors, setErrors] = useState({}); //error show state
  const [filteredTask, setFilteredTasks] = useState([]); // For search functionality
  const [showDatePicker, setShowDatePicker] = useState(false); //open calender on click  
  // const [subtask, setSubTasks] = useState([]);
  const [selectedDeadline, setSelectedDeadline] = useState(new Date()); // single deadline date
  const [subtaskData, setSubtaskData] = useState(null); // State to store subtask data
  const [isProgressModalOpen, setIsProgressModalOpen] = useState(false); // Modal open state
  //This is for File uploading
  // eslint-disable-next-line
  const [previewImage, setPreviewImage] = useState("");
  const userData = JSON.parse(localStorage.getItem("user")); //get id from local storage
  const userId = userData.id;
  const userRole = userData.role;
  const [DescriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [progress, setProgress] = useState(0);
  const [minProgress, setMinProgress] = useState(0);
  const [comment, setComment] = useState("");

  // Reject Note Modal state
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectNote, setRejectNote] = useState("");
  const [rejectTaskDetails, setRejectTaskDetails] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const messagesEndRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = () => setOpenDropdownId(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isProgressModalOpen) {
      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, [subtaskData, isProgressModalOpen]);
  const handleOpenReplyModal = (subtask) => {
    console.log("Opening Reply Modal for Subtask:", subtask);
    if (!subtask.task_update_id) {
      toast.error("Error: Subtask is missing!");
      console.error("Error: Subtask ID (task_update_id) is missing!");
      return;
    }
    setSelectedSubtask(subtask);  // Store the selected subtask correctly
    const currentProg = Number(subtask.task_progress || subtask.TUM_Progress || 0);
    setProgress(currentProg);
    setMinProgress(currentProg);
    setComment(""); // Always start with an empty comment for a new reply
    setIsReplyModalOpen(true);
  };
  //set data
  const [formData, setFormData] = useState({
    project_task_project_id: "",
    project_task_assignto: [],
    project_task_assignby: userId,
    project_task_priority: "",
    project_task_title: "",
    project_task_Description: "",
    project_task_duration: "",
    project_task_isstart: "",
    project_task_iscompleted: "",
    project_task_isactive: true, //by default set
    project_task_status: "Pending", //by default set
    project_task_attach_file: "",
  });
  const [editMode, setEditMode] = useState(false); // Edit mode flag
  // Fetch employees, managers, team leader data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/emp"
      );
      console.log("response------->", response.data.employees.employee_role);
      // Filter both employees and managers
      const employeeData = response.data.employees
        // Include both roles
        .map((emp) => ({
          Employee_id: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
          Role: emp.employee_role, // Include role for reference
        }));
      console.log("employeeData--->", employeeData);
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);



  // Fetch Project data from the API
  const fetchProject = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/projects"
      );
      const projectData = response.data.project.map((project) => ({
        ProjectId: project.project_id,
        ProjectName: project.project_name,
      }));
      console.log("project-->", projectData.ProjectName);
      setProject(projectData);
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchProject();
  }, []);

  //featch Task data from the API
  // Fetch Task data and map with project and employee data
  const fetchTasks = async () => {
    setLoading(true);
    try {
      let taskUrl = `/api/tasks`;

      // Fetch task, project, and employee data in parallel
      const [taskRes, projectRes, employeeRes] = await Promise.all([
        axios.get(taskUrl),
        axios.get("/api/projects"),
        axios.get("/api/emp")
      ]);

      const taskData = taskRes.data.task.map((t) => ({
        TaskId: t.project_task_id,
        ProjectId: t.project_task_project_id,
        TaskAssignTo: t.project_task_assignto,
        TaskAssignBy: t.project_task_assignby,
        Priority: t.project_task_priority,
        TaskTitle: t.project_task_title,
        TaskDescription: t.project_task_Description,
        TaskDuration: t.project_task_duration,
        TaskIsStart: t.project_task_isstart,
        TaskIsCompleted: t.project_task_iscompleted,
        TaskIsActive: t.project_task_isactive,
        TaskStatus: t.project_task_status,
        TaskFile: t.project_task_attach_file,
      }));
      console.log("taskDatas--->", taskData);

      const projectData = projectRes.data.project;
      const employeeData = employeeRes.data.employees;
      // Map task data with project and employee details
      const taskDataWithDetails = taskData.map((task) => {
        // Find the corresponding project
        const project = projectData.find(
          (proj) => proj.project_id === task.ProjectId
        );
        // Find the corresponding employee
        const employee = employeeData.find(
          (emp) => emp.employee_id === task.TaskAssignTo
        );
        // console.log("employeeemployeeemployee-->", employee.employee_role);
        if (!employee) {
          console.error(
            `No employee found for TaskAssignTo: ${task.TaskAssignTo}`
          );
        }


        // Return enriched task data
        return {
          ...task,
          ProjectName: project ? project.project_name : "Unknown Project",
          EmployeeName: employee
            ? `${employee.employee_first_name} ${employee.employee_last_name}`
            : "Unknown Employee",
        };
      });

      // Update tasks state with the enriched data
      setTasks(taskDataWithDetails);
      setFilteredTasks(taskDataWithDetails);
    } catch (error) {
      console.error("Error fetching task, project or employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTasks();
  }, []);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  //open modal
  const openModal = (taskData = null) => {
    if (taskData) {
      setFormData(taskData);
      setEditMode(true);
    } else {
      setFormData({
        project_task_project_id: "",
        project_task_assignto: [],
        // project_task_assignto: "",
        project_task_assignby: userId,
        project_task_priority: "",
        project_task_title: "",
        project_task_Description: "",
        project_task_duration: "",
        project_task_isstart: "",
        project_task_iscompleted: "",
        project_task_isactive: true, //by default set
        project_task_status: "Pending", //by default set
        project_task_attach_file: "",
      });
      setEditMode(false);
    }
    // Reset validation errors
    setErrors({});
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  //single-date selection
  const handleDateChange = (date) => {
    setSelectedDeadline(date);
    setFormData({
      ...formData,
      project_task_duration: `${dayjs().format("DD-MM-YYYY")} - ${dayjs(date).format("DD-MM-YYYY")}`, // Automatically prepend Today's date
    });
    setShowDatePicker(false); // Hide the date picker after selecting
  };
  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker); // Toggle date picker visibility
  };

  //edit
  const handleEdit = (t) => {
    if (t.TaskStatus === "Completed") {
      toast.warn("Completed tasks cannot be edited.");
      return;
    }
    setFormData({
      project_task_id: t.TaskId,
      project_task_project_id: t.ProjectId,
      project_task_assignto: t.TaskAssignTo || "",
      project_task_assignby: t.TaskAssignBy,
      project_task_priority: t.Priority || "",
      project_task_title: t.TaskTitle || "",
      project_task_Description: t.TaskDescription || "",
      project_task_duration: t.TaskDuration || "",
      project_task_isstart: t.TaskIsStart || "",
      project_task_iscompleted: t.TaskIsCompleted || "",
      project_task_isactive: t.TaskIsActive || "",
      project_task_status: t.TaskStatus || "",
      project_task_attach_file: t.TaskFile || "",
    });
    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with pre-filled data
  };

  //delete
  // Handle delete action, set task name and ID
  const handleDelete = async (t) => {
    const task_id = t.TaskId;
    const task_name = t.TaskTitle;
    if (!task_id) {
      toast.error("Invalid task ID. Please try again.");
      return;
    }
    // Set task name and ID to state before showing the pop-up
    setDeleteServiceName(task_name); // Dynamically sets the task name
    setDeleteServiceId(task_id); // Dynamically sets the task ID
    setShowDeleteBox(true); // Show the confirmation popup
  };
  // Confirm delete action
  const confirmDelete = async () => {
    if (!deleteServiceId) return;
    try {
      const response = await axios.delete(
        `/api/task/delete/${deleteServiceId}`
      );
      if (response.status === 200) {
        toast.success("Task deleted successfully!");
        const updatedTasks = tasks.filter(
          (item) => item.TaskId !== deleteServiceId
        );
        setTasks(updatedTasks);
        setFilteredTasks(updatedTasks);
      }
      setShowDeleteBox(false); // Close the confirmation box after deletion
    } catch (error) {
      console.error("Error deleting Task:", error);
      toast.error("An error occurred while deleting the Task.");
      setShowDeleteBox(false); // Close the box on error
    }
  };
  // Cancel delete action
  const cancelDelete = () => {
    setShowDeleteBox(false); // Close the confirmation box without deleting
  };
  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit--->");
    // Validate the form
    const validateForm = () => {
      const newErrors = {};
      if (!formData.project_task_title) {
        newErrors.project_task_title = "Task Title is required.";
      }
      if (!formData.project_task_assignto) {
        newErrors.project_task_assignto = "Employee Name is required.";
      }
      if (!formData.project_task_priority) {
        newErrors.project_task_priority = "Priority is required.";
      }
      if (!formData.project_task_duration) {
        newErrors.project_task_duration = "Task Duration is required.";
      }
      if (!formData.project_task_project_id) {
        newErrors.project_task_project_id = "Project Name is required.";
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    try {
      const url = editMode
        ? `/api/task/update/${formData.project_task_id}`
        : "/api/task/add";
      const method = editMode ? "put" : "post";
      // Send API request
      await axios({
        method,
        url,
        data: formData,
      });
      toast.success(
        editMode ? "Task updated successfully!" : "Task added successfully!"
      );
      fetchTasks(); // Refresh task list
      closeModal();
      setErrors({});
    } catch (error) {
      console.error("Error submitting task data:", error);
      toast.error("Failed to submit data. Please try again.");
    }
  };

  //for upload file attachment in task
  const handleFileUpload = async (taskId, file) => {
    if (!file) {
      toast.error("Please select a file.");
      return;
    }
    const formData = new FormData();
    formData.append("project_task_attach_file", file);
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/task/add-attachment/${taskId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("File uploaded successfully!");
        fetchTasks(); // Refresh tasks after upload
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("File Type Must Be: pdf, doc, docx, xlsx, csv, txt, png, jpg, jpeg");
    }
  };
  //function for delete the file
  const handleFileDelete = async (t) => {
    const task_id = t.TaskId;
    if (!task_id) {
      toast.error("Invalid task ID. Please try again.");
      return;
    }
    const confirmed = window.confirm(
      "Are you sure you want to delete this task File?"
    );
    if (!confirmed) return;
    try {
      const response = await axios.delete(
        `/api/task/delete-attachment/${task_id}`
      );
      console.log("response", response);
      if (response.status === 200 || response.status === 201) {
        // Remove the deleted tasks from the state
        toast.success("Task File deleted successfully!");
        console.log("success delete");
        fetchTasks();
      }
    } catch (error) {
      console.error("Error deleting Task:", error);
      toast.error("An error occurred while deleting the Task.");
    }
  };

  //Handle Progress for showing a progress data in modal
  const handleProgress = async (project_task_id) => {
    console.log("Fetching progress for TaskId:", project_task_id);
    // setLoading(true);
    try {
      const response = await fetch(
        `/api/subtasks/projecttask/${project_task_id.TaskId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch progress data");
      }
      const data = await response.json();
      if (response.status === 200 || response.status === 201) {
        setSubtaskData(data); // Reverse the fetched data before setting state
        setIsProgressModalOpen(true); // Open the modal
      } else {
        toast.error("No progress data available for this task.");
      }
    } catch (err) {
      toast.warn("No progress data available for this task.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // Function to handle status update
  const handleStatusChange = async (taskId, newStatus, note = "") => {
    if (!newStatus) {
      toast.error("Invalid status update");
      return;
    }
    try {
      const payload = { project_task_status: newStatus };
      if (note) {
        payload.reject_note = note;
      }

      const response = await axios.put(
        `/api/task/${taskId}/status`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success(`Task marked as ${newStatus}`);
        fetchTasks(); // Refresh task list after update so UI syncs
      } else {
        toast.error("Failed to update task status.");
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Error updating task status.");
    }
  }; useEffect(() => {
    const fetchSubtasks = async () => {
      try {
        const response = await fetch("/api/subtasks");
        if (!response.ok) {
          throw new Error("Failed to fetch subtasks");
        }
        const data = await response.json();
        console.log("Fetched Subtasks:", data); // Debugging
        setSubtaskData(data); // Update state with fetched data
      } catch (error) {
        console.error("Error fetching subtasks:", error);
      }
    };
    fetchSubtasks();
  }, []);

  const handleReplySubmit = async () => {
    console.log("Selected Subtask in handleReplySubmit:", selectedSubtask);
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    const userId = loggedInUser.id || loggedInUser.employee_id || loggedInUser.EMP_Id || loggedInUser.Admin_id || loggedInUser.admin_id;
    if (!selectedSubtask) {
      console.error("Error: No subtask selected!");
      return;
    }

    // We send to /api/subtask/add to create a NEW chat bubble instead of overwriting!
    const payload = {
      task_ptm_id: Number(selectedSubtask.task_ptm_id || selectedSubtask.TUM_PTM_Id),
      task_Updateby: Number(userId),
      task_progress: String(progress),
      task_comment: comment.trim(),
      task_isactive: true,
      task_attach_file: "",
      task_created_at: new Date().toISOString(),
      task_updated_at: new Date().toISOString(),
    };

    try {
      const response = await fetch("/api/subtask/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const responseText = await response.text();
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (e) {
        result = { message: responseText };
      }

      if (response.ok) {
        toast.success("Progress updated successfully!");
        setIsReplyModalOpen(false);
        setComment("");
        // Re-fetch progress to update UI instantly
        handleProgress({ TaskId: payload.task_ptm_id });
      } else {
        toast.error(`Failed to update: ${result.message || "Server Error"}`);
      }
    } catch (error) {
      toast.error("Error Updating Subtask");
      console.error("Error updating subtask:", error);
    }
  };

  //Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    { Header: "Title", accessor: "TaskTitle" },
    {
      Header: "Description",
      accessor: "TaskDescription",
      className: "table-cell capitalize-text",
      Cell: ({ row }) => {
        const fullDescription = `${row.original.TaskDescription}`;
        const truncatedDescription =
          fullDescription.length > 15
            ? `${fullDescription.substring(0, 15)}...`
            : fullDescription;
        return (
          <>
            <span>{truncatedDescription}</span>
            {fullDescription.length > 15 && (
              <Button
                size="small"
                color="primary"
                onClick={() => {
                  setSelectedDescription(fullDescription);
                  setDescriptionDialogOpen(true);
                }}
              >
                Read More
              </Button>
            )}
          </>
        );
      },
    },
    { Header: "Project", accessor: "ProjectName" },
    {
      Header: "Employee",
      accessor: "EmployeeName",
      Cell: ({ row }) => `${row.original.EmployeeName}`,
    },
    { Header: "Duration", accessor: "TaskDuration" },
    {
      Header: "Priority",
      accessor: "Priority",
      Cell: ({ value }) => (
        <span
          style={{
            color:
              value === "High"
                ? "#e74c3c"
                : value === "Medium"
                  ? "#f39c12"
                  : value === "Low"
                    ? "#27ae60"
                    : "black", // Default color
            fontWeight: "bold",
          }}
        >
          {value}
        </span>
      ),
    },
    {
      Header: "Status",
      accessor: "TaskStatus",
      Cell: ({ row }) => {
        const [status, setStatus] = useState(row.original.TaskStatus);
        const isOpen = openDropdownId === row.original.TaskId;
        const handleDropdownChange = (newStatus) => {
          if (newStatus === "Ongoing") {
            setRejectTaskDetails({ taskId: row.original.TaskId, newStatus });
            setIsRejectModalOpen(true);
            setOpenDropdownId(null);
            return;
          }
          setStatus(newStatus);
          handleStatusChange(row.original.TaskId, newStatus);
          setOpenDropdownId(null); // Close dropdown after selection
        };
        return (
          <div
            style={{ position: "relative", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setOpenDropdownId(isOpen ? null : row.original.TaskId);
            }}
          >
            <span
              className="status-badge"
              style={{
                color: "white",
                background:
                  status === "Pending"
                    ? "#ff4d4d" // Vibrant red
                    : status === "Ongoing"
                      ? "#ffa500" // Vibrant Orange
                      : status === "InReview" || status === "In Review"
                        ? "#3b82f6" // Vibrant Blue
                        : status === "Completed"
                          ? "#2ecc71" // Vibrant Green
                          : "#ffa500",
                fontWeight: "700",
                borderRadius: "8px",
                padding: "6px 12px",
                cursor: "pointer",
                display: "inline-block",
                fontSize: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
              }}
            >
              {status}
            </span>
            {isOpen && (
              <div
                className="dropdown-menu"
                style={{
                  position: "absolute",
                  background: "var(--bg-card)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid var(--border)",
                  padding: "8px",
                  left: "80%",
                  ...(row.rowIndexInPage < row.currentPageSize / 2 ? { top: "0" } : { bottom: "0" }),
                  marginLeft: "12px",
                  borderRadius: "12px",
                  boxShadow: "0px 10px 30px rgba(0,0,0,0.5)",
                  zIndex: 999,
                  minWidth: "120px"
                }}
              >
                {["Ongoing", "Completed"].map((option) => (
                  <div
                    key={option}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      borderRadius: "6px",
                      color: "var(--text-main)",
                      fontSize: "13px",
                      fontWeight: "500",
                      background: option === status ? "rgba(255,255,255,0.1)" : "transparent",
                      transition: "all 0.2s ease"
                    }}
                    onMouseEnter={(e) => e.target.style.background = "rgba(255,255,255,0.1)"}
                    onMouseLeave={(e) => e.target.style.background = option === status ? "rgba(255,255,255,0.1)" : "transparent"}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownChange(option);
                    }}
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: "File",
      accessor: "TaskFile",
      Cell: ({ row }) => {
        const [isHovered, setIsHovered] = useState(false);
        const hasFile = !!row.original.TaskFile; // Check if file exists
        return (
          <div
            className="file-cell"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* If no file, show upload option */}
            {!hasFile ? (
              <>
                <label
                  htmlFor={`file-upload-${row.original.TaskId}`}
                  className="file-upload-label"
                >
                  <FaFileUpload className="file-icon" />
                </label>
                <input
                  type="file"
                  id={`file-upload-${row.original.TaskId}`}
                  style={{ display: "none" }}
                  onChange={(e) =>
                    handleFileUpload(row.original.TaskId, e.target.files[0])
                  }
                />
              </>
            ) : (
              <>
                {/* Show Preview Icon */}
                <MdPreview className="file-icon" />
                {/* Show options on hover */}
                {isHovered && (
                  <div className="file-hover-options">
                    <a
                      href={row.original.TaskFile}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="file-option"
                    >
                      <MdPreview className="file-icon" />
                      Preview
                    </a>
                    <button
                      onClick={() => handleFileDelete(row.original)}
                      className="file-delete-button"
                    >
                      <MdDelete className="file-icon" />
                      Delete
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];
  // eslint-disable-next-line
  const hasAccess = (allowedRoles) => {
    const userRole = localStorage.getItem("role");
    return allowedRoles.includes(userRole);
  };
  return (
    <div>
      <ToastContainer />
      {loading}
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <BsListCheck /> Task
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>
      {/* //For progress modal show  */}
      <Modal
        isOpen={isProgressModalOpen}
        onRequestClose={() => setIsProgressModalOpen(false)}
        contentLabel="Task Progress"
        className="progress-modal"
        shouldCloseOnOverlayClick={true}
      >
        <div className="progress-modal-content" style={{ background: "#1e293b", color: "white", padding: "20px", borderRadius: "12px", width: "100%", maxWidth: "600px", border: "1px solid #334155" }}>
          <Typography variant="h5" style={{ color: "#38bdf8", fontWeight: "bold", marginBottom: "20px", textAlign: "center" }}>
            Task Progress & Updates
          </Typography>
          {subtaskData && subtaskData.subtasks ? (
            <div className="hide-scrollbar" style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "30px", maxHeight: "400px", overflowY: "auto", padding: "16px", background: "rgba(15, 23, 42, 0.4)", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.05)" }}>
              {subtaskData.subtasks.map((st, index) => {
                const updatedById = st.task_Updateby || st.TUM_UpdateBy;
                const updaterName = employee.find(emp => emp.Employee_id === updatedById)?.EmployeeName || "Unknown";
                const role = localStorage.getItem("role");

                const userProfile = JSON.parse(localStorage.getItem("userProfile")) || {};
                const loggedInName = role === "admin"
                  ? (userProfile?.admin_fullname || userData?.FullName || userData?.admin_fullname || "")
                  : `${userProfile?.employee_first_name || userData?.EMP_F_Name || ''} ${userProfile?.employee_last_name || userData?.EMP_L_Name || ''}`.trim();

                const isMyUpdate = String(updatedById) === String(userId) || (updaterName?.toLowerCase().trim() === loggedInName?.toLowerCase().trim() && updaterName !== "Unknown");

                return (
                  <div key={index} style={{ display: "flex", justifyContent: isMyUpdate ? "flex-end" : "flex-start", width: "100%" }}>
                    <div style={{
                      maxWidth: "75%",
                      padding: "10px 14px",
                      borderRadius: isMyUpdate ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                      background: isMyUpdate ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)" : "#334155",
                      color: "#fff",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    }}>
                      {!isMyUpdate && (
                        <Typography style={{ fontSize: "12px", color: "#93c5fd", fontWeight: "bold", marginBottom: "4px" }}>
                          {updaterName}
                        </Typography>
                      )}

                      <Typography style={{ fontSize: "14px", marginBottom: "4px", lineHeight: "1.4", wordBreak: "break-word" }}>
                        {st.task_comment || st.TUM_Comment}
                      </Typography>

                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "15px", marginTop: "6px" }}>
                        <span style={{ fontSize: "10px", color: isMyUpdate ? "rgba(255,255,255,0.7)" : "#cbd5e1" }}>
                          {(st.task_updated_at || st.updated_at || st.created_at) ? new Date(st.task_updated_at || st.updated_at || st.created_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase() : ""}
                        </span>

                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                          <span style={{ fontSize: "10px", background: isMyUpdate ? "rgba(255,255,255,0.2)" : "rgba(16, 185, 129, 0.2)", color: isMyUpdate ? "#fff" : "#10b981", padding: "2px 6px", borderRadius: "10px", fontWeight: "bold" }}>
                            {st.task_progress || st.TUM_Progress}%
                          </span>

                          {/* Attached File Section */}
                          {st.task_attach_file && (
                            <a href={st.task_attach_file} target="_blank" rel="noopener noreferrer" style={{ color: isMyUpdate ? "#fff" : "#38bdf8", textDecoration: "none", display: "flex", alignItems: "center" }}>
                              <MdPreview style={{ fontSize: "16px" }} />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              <div ref={messagesEndRef} />
            </div>
          ) : (
            <p className="loading-text" style={{ textAlign: "center", color: "#94a3b8" }}>Loading task progress...</p>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            <Button
              variant="contained"
              onClick={() => {
                if (subtaskData && subtaskData.subtasks && subtaskData.subtasks.length > 0) {
                  handleOpenReplyModal(subtaskData.subtasks[subtaskData.subtasks.length - 1]);
                } else {
                  toast.error("No subtask to reply to.");
                }
              }}
              style={{ background: "linear-gradient(135deg, #38bdf8 0%, #3b82f6 100%)", color: "white", borderRadius: "8px", textTransform: "none", fontWeight: "bold", padding: "8px 24px" }}
            >
              Reply / Update Progress
            </Button>
            <Button
              variant="contained"
              onClick={() => setIsProgressModalOpen(false)}
              style={{ marginLeft: "15px", background: "#334155", borderColor: "#475569", color: "#f1f5f9", borderRadius: "8px", textTransform: "none", fontWeight: "bold", padding: "8px 24px", boxShadow: "0 4px 6px rgba(0,0,0,0.2)" }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
      {/* modal for reply subtask  */}
      <Modal
        isOpen={isReplyModalOpen}
        onRequestClose={() => setIsReplyModalOpen(false)}
        contentLabel="Update Progress"
        className="reply-modal"
      >
        <div className="reply-modal-content">
          <div className="reply-modal-progress">
            <h2>Update Progress</h2>
            <Slider
              value={progress}
              onChange={(e, val) => setProgress(Math.max(val, minProgress))}
              min={minProgress}
              max={100}
              step={10}
              valueLabelDisplay="auto"
            />
            <Typography>Progress: {progress}%</Typography>
          </div>
          <div className="reply-bodal-comment">
            <TextField
              label="Task Comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              fullWidth
            />
          </div>
          <div className="reply-modal-btn">
            <button className="reply-submit-button" onClick={handleReplySubmit}>
              Submit
            </button>
            <button className="reply-close-button" onClick={() => setIsReplyModalOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredTask.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleProgress={handleProgress}
          isTaskProgress={true}
          isDeleteAction={userRole === "admin" || userRole === "manager"} // Only show delete action for admin or manager
          isEditAction={true}
        />
      )}
      {/* Address */}
      <Dialog
        open={DescriptionDialogOpen}
        onClose={() => setDescriptionDialogOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6">Description</Typography>
          <Typography variant="body2">{selectedDescription}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDescriptionDialogOpen(false)} style={{ backgroundColor: "red", color: "white" }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Reject Task Note Modal */}
      <Dialog
        open={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <Typography variant="h6" style={{ marginBottom: "15px", fontWeight: "bold" }}>Return Task to Ongoing</Typography>
          <Typography variant="body2" style={{ marginBottom: "10px" }}>Please enter a note explaining what work is remaining:</Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Enter your remarks here..."
            value={rejectNote}
            onChange={(e) => setRejectNote(e.target.value)}
          />
        </DialogContent>
        <DialogActions style={{ padding: "15px" }}>
          <Button onClick={() => {
            setIsRejectModalOpen(false);
            setRejectNote("");
          }} style={{ backgroundColor: "#9ca3af", color: "white" }}>Cancel</Button>
          <Button onClick={() => {
            if (!rejectNote.trim()) {
              toast.error("Please enter a note.");
              return;
            }
            // Temporarily update UI status and call API
            handleStatusChange(rejectTaskDetails.taskId, rejectTaskDetails.newStatus, rejectNote);
            setIsRejectModalOpen(false);
            setRejectNote("");
          }} style={{ backgroundColor: "#3b82f6", color: "white" }}>Submit</Button>
        </DialogActions>
      </Dialog>
      {/* Custom Delete Confirmation Box */}
      {showDeleteBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the task{" "}
              <span className="task-name">
                <strong>{deleteServiceName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDelete} // Trigger confirmDelete
              >
                Yes, Delete
              </button>
              <button
                className="cancel-button"
                onClick={cancelDelete} // Trigger cancelDelete
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal} //other click on screen, never close form modal
        contentLabel="Task Form"
        className="add-task-modal"
        shouldCloseOnOverlayClick={false}
        style={{
          content: {
            width: "380px",
          },
        }}
      >
        <h2>{editMode ? "Edit Task" : "Add Task"}</h2>
        <form className="task-form" onSubmit={handleSubmit}>
          <div className="form-container">
            {/* Row 1 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  label="Task Title"
                  name="project_task_title"
                  value={formData.project_task_title}
                  error={!!errors.project_task_title}
                  helperText={errors.project_task_title}
                  onChange={handleInputChange}
                  style={{ width: "170px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <BiTask />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="form-field">
                <TextField
                  select
                  label="Project Name"
                  name="project_task_project_id"
                  value={formData.project_task_project_id}
                  error={!!errors.project_task_project_id}
                  helperText={errors.project_task_project_id}
                  onChange={handleInputChange}
                  // disabled={editMode} //Disable when editing
                  fullWidth
                  style={{ width: "170px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <AiOutlineProject />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Project</MenuItem>
                  {project.map((project) => (
                    <MenuItem key={project.ProjectId} value={project.ProjectId}>
                      {project.ProjectName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            {/* Row 2 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  select
                  label="Assign To"
                  name="project_task_assignto"
                  value={formData.project_task_assignto}
                  error={!!errors.project_task_assignto}
                  helperText={errors.project_task_assignto}
                  onChange={handleInputChange}
                  // disabled={editMode} //Disable when editing
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdAssignmentInd />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Employee</MenuItem>
                  {employee
                    .filter((emp) => {
                      if (userRole === "manager") {
                        return emp.Role !== "M"; // Hide "Manager" role for managers
                      } else if (userRole === "Team Leader") {
                        return emp.Role !== "T" && emp.Role !== "M";
                      }
                      return true; // Show all roles for other users (admin)
                    })
                    .map((employees) => (
                      <MenuItem
                        key={employees.Employee_id}
                        value={employees.Employee_id}
                      >
                        {employees.EmployeeName} - {employees.Role}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
              <div className="form-field">
                <TextField
                  select
                  label="Priority"
                  name="project_task_priority"
                  value={formData.project_task_priority}
                  error={!!errors.project_task_priority}
                  helperText={errors.project_task_priority}
                  onChange={handleInputChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdOutlineLowPriority />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem>Select Priority</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                </TextField>
              </div>
            </div>
            {/* Row 3 */}
            <div className="form-row">
              <div className="form-field">
                {/* Input Field with Calendar Icon */}
                <TextField
                  label="Task Duration"
                  name="project_task_duration"
                  value={formData.project_task_duration}
                  error={!!errors.project_task_duration}
                  helperText={errors.project_task_duration}
                  onClick={toggleDatePicker} // Open date picker on click
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaCalendarAlt
                          onClick={toggleDatePicker}
                          style={{ cursor: "pointer" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  readOnly // Make the input field readonly
                />
              </div>
              {/* Conditional Rendering of Calendar (Deadline only) */}
              {showDatePicker && (
                <div
                  className="calendar-responsive-container"
                  style={{
                    position: "absolute",
                    left: "395px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 999
                  }}
                >
                  <Calendar
                    date={selectedDeadline}
                    onChange={handleDateChange}
                    locale={enUS}
                    color="var(--primary)"
                  />
                </div>
              )}
            </div>
            {/* Row 4 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  label="Description"
                  name="project_task_Description"
                  id="outlined-textarea"
                  value={formData.project_task_Description}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  minRows={4} // Increased height for better description input
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <BsTextParagraph />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="all-button-form">
            <button type="submit">{editMode ? "Save" : "+Add"}</button>
            <button type="button" onClick={closeModal} className="close-button">
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default TaskPage;
